import { inject, Injectable, signal } from '@angular/core';
import { SessionStorageService } from 'src/app/services/session-storage.service';

@Injectable({
  providedIn: 'root'
})
export class PlannerDayStateService {
  private _dayToShowIndex = signal(0);
  public dayToShowIndex = this._dayToShowIndex.asReadonly();
  
  public _sessionStorageService = inject(SessionStorageService);
  
  setDayToShowIndex(index: number): void {
    this._dayToShowIndex.set(index);
    this._sessionStorageService.setItem('dayToShowIndex', index);
  }
  
  resetDayToShowIndex(): void {
    this._dayToShowIndex.set(0);
    this._sessionStorageService.removeItem('dayToShowIndex');
  }
}
 